import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-dance-room',
  templateUrl: './dance-room.component.html',
  styleUrls: ['./dance-room.component.scss']
})
export class DanceRoomComponent implements OnInit {
  activeLightboxImage: string | null = null;

  danceImages = [
    '/assets/img/facilities/imgi_287_dance_music_img1-1200x800.jpg',
    '/assets/img/facilities/imgi_284_dance_music_img2-1200x800.jpg',
    '/assets/img/facilities/imgi_281_dance_music_img3-1200x800.jpg',
    '/assets/img/facilities/imgi_278_dance_music_img4-1200x800.jpg'
  ];

  danceVideos = [
    { title: 'Music & Rhythmic Session 1', src: '/assets/mp4/music_1.mp4' },
    { title: 'Music & Rhythmic Session 2', src: '/assets/mp4/music_2.mp4' }
  ];

  constructor() { }

  ngOnInit(): void {
  }

  openLightbox(src: string): void {
    this.activeLightboxImage = src;
  }

  closeLightbox(): void {
    this.activeLightboxImage = null;
  }
}

